package io.horion.cv.api.datasource.motivation

import io.horion.cv.api.datasource.common.PersonalInformation
import io.horion.cv.api.datasource.common.Type
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class Letter(
    @SerialName("_id")
    val id: String = "",
    val uuid: String = "",
    val user: String? = null,
    val owner: String = "",
    val personalInformation: PersonalInformation =  PersonalInformation(),
    val letterTitle : String =  "",
    val destination: String = "",
    val date: String = "",
    val subject: String = "Candidatre spontanee au poste de developpeur Mobile Kotlin",
    val introduction: String = "Je vous prie de bien vouloir considérer ma candidature pour un poste au sein de votre entreprise. Disposant d’une réelle motivation pour évoluer dans un environnement professionnel exigeant, je souhaite mettre à profit mes compétences, mon sens des responsabilités et ma capacité d’adaptation au service de votre équipe.",
    val situation: String = "Au cours de mes expériences précédentes, j’ai développé un sens aigu de l’organisation, de la rigueur et de la collaboration. Habitué(e) à travailler avec des objectifs clairs, je veille à respecter les délais et à maintenir un haut niveau de qualité dans les tâches qui me sont confiées. Mon aisance relationnelle me permet également de collaborer efficacement avec des interlocuteurs variés.",
    val motivation: String = "Consciencieux(se) et impliqué(e), je suis prêt(e) à m’investir pleinement pour contribuer aux résultats de votre structure et à m’intégrer rapidement à vos méthodes de travail.",
    val conclusion: String = "Je vous remercie par avance de l’attention portée à cette candidature et reste à votre disposition pour un entretien.",
    val others: List<String> = emptyList(),
    val motivationConfig: MotivationConfig = MotivationConfig(),
    val type: Type = Type.PERSONNEL,
)